import React, { useState, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import analyticsUtils from 'src/scripts/utilities/analyticsUtils';
const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]';
export const getFirstFocusable = (parent) => parent.querySelector(focusableSelectors);
export const getAllFocusableElements = (parent) => parent.querySelectorAll(focusableSelectors);
const AddressNotFoundModal = (props) => {
    var _a, _b;
    const { t } = props;
    const [selectedOption, setSelectedOption] = useState('');
    const modalRef = useRef(null);
    const overlayRef = useRef(null);
    const lastFocusedElementRef = useRef(null);
    const trapFocus = (event) => {
        const focusableElements = getAllFocusableElements(modalRef.current);
        const firstFocusableElement = getFirstFocusable(modalRef.current);
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus();
                    event.preventDefault();
                }
            }
            else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
                    event.preventDefault();
                }
            }
        }
    };
    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleSubmit = () => {
        var _a;
        let pid = document.querySelector('.connectivity-container').getAttribute('data-pid');
        let data = {
            'forcedPipeline': 'ConnectivityModalCta',
            'pid': pid
        };
        analyticsUtils.passThroughProcessor(data);
        const selectedAddress = (_a = props.addressSuggestions) === null || _a === void 0 ? void 0 : _a.find((address) => address.indirizzo === selectedOption);
        if (selectedAddress) {
            const addressDetails = {
                city: selectedAddress.provincia,
                address: selectedAddress.indirizzo,
                civic: selectedAddress.civic_number || '',
            };
            props.onVerifyCoverage(addressDetails);
        }
        else if (selectedOption === 'Mantieni il mio indirizzo' || selectedOption === 'Modifica l\'indirizzo di copertura') {
            props.onVerifyCoverage({ choice: selectedOption });
        }
        props.closeModal();
    };
    useEffect(() => {
        lastFocusedElementRef.current = document.activeElement;
        const firstFocusableElement = getFirstFocusable(modalRef.current);
        firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
        document.addEventListener('keydown', trapFocus);
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                props.onVerifyCoverage({ choice: 'Modifica l\'indirizzo di copertura' });
                props.closeModal();
            }
        };
        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', trapFocus);
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [props.closeModal, props.onVerifyCoverage]);
    useEffect(() => {
        return () => {
            if (lastFocusedElementRef.current) {
                lastFocusedElementRef.current.focus();
            }
        };
    }, [props.closeModal]);
    const handleOverlayClick = (event) => {
        if (overlayRef.current && overlayRef.current === event.target) {
            props.onVerifyCoverage({ choice: 'Modifica l\'indirizzo di copertura' });
            props.closeModal();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: overlayRef, className: " modal-overlay", onClick: handleOverlayClick }),
        React.createElement("div", { ref: modalRef, className: "modal-container" },
            React.createElement("button", { className: "modal--micromodal-close modal-close-btn", "aria-label": t('common.close'), "data-modal-close": true, onClick: () => {
                    props.onVerifyCoverage({ choice: 'Modifica l\'indirizzo di copertura' });
                    props.closeModal();
                } }),
            React.createElement("h1", { className: "font-primary-2xl-bold connectivity-title modal-title" },
                " ",
                t('connectivity.modal.title'),
                " "),
            React.createElement("h1", { className: "font-primary-xs-regular  modal-description", dangerouslySetInnerHTML: { __html: t('connectivity.modal.description') } }),
            ((_a = props.addressSuggestions) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement("h1", { className: "font-primary-xs-regular modal-description" }, t('connectivity.modal.sugg'))) : (React.createElement("h1", { className: "font-primary-xs-regular modal-description" }, t('connectivity.modal.notfound'))),
            React.createElement("form", { className: "address-form" },
                React.createElement("fieldset", null,
                    React.createElement("legend", { className: "visually-hidden" }), (_b = props.addressSuggestions) === null || _b === void 0 ? void 0 :
                    _b.slice(0, props.addressSuggestionsNumMax).map((address, index) => (React.createElement("div", { key: index, className: "  form-item" },
                        React.createElement("input", { type: "radio", id: address.egon_code.toString(), name: "address", value: address.indirizzo, checked: selectedOption === address.indirizzo, onChange: handleOptionChange, className: "  radio-button" }),
                        React.createElement("label", { htmlFor: address.egon_code.toString(), className: "font-primary-xs-regular modal-choice" },
                            `${address.indirizzo}, `,
                            address.civic_number && `${address.civic_number}, `,
                            address.provincia,
                            address.cap && ` (${address.cap})`))))),
                React.createElement("hr", { className: "hr-line" }),
                React.createElement("fieldset", null,
                    React.createElement("legend", { className: "visually-hidden" }),
                    React.createElement("div", { className: "form-item" },
                        React.createElement("input", { type: "radio", id: "mantieniIndirizzo", name: "address", value: "Mantieni il mio indirizzo", checked: selectedOption === 'Mantieni il mio indirizzo', onChange: handleOptionChange, className: "radio-button" }),
                        React.createElement("label", { htmlFor: "mantieniIndirizzo", className: "font-primary-xs-regular modal-choice" }, t('connectivity.modal.sameaddress'))),
                    React.createElement("div", { className: "form-item" },
                        React.createElement("input", { type: "radio", id: "modificaIndirizzo", name: "address", value: "Modifica l'indirizzo di copertura", checked: selectedOption === 'Modifica l\'indirizzo di copertura', onChange: handleOptionChange, className: "radio-button" }),
                        React.createElement("label", { htmlFor: "modificaIndirizzo", className: "font-primary-xs-regular modal-choice" }, t('connectivity.modal.differentaddress'))))),
            React.createElement("button", { type: "submit", className: "cta cta-primary cta-btn", onClick: handleSubmit }, t('connectivity.modal.verify')))));
};
export default withTranslation()(AddressNotFoundModal);
